import type { HttpClient, RequestConfig } from '@mathflat/domain/http/client'
import axios from 'axios'

import maxios from './maxios'

// 이 앱의 maxios 는 두 가지가 타입과 어긋난다. 그 어긋남을 이 한 곳에서 흡수한다.
//
// 1. 응답 인터셉터가 이미 본문을 돌려주는데 타입은 AxiosResponse 라고 말한다.
// 2. 404·501 이상은 reject 되지 않고 AxiosError 가 그대로 resolve 된다.
//
// domain 의 HttpClient 는 본문으로 resolve 한다고 약속하므로, 에러가 실려 오면 reject 로 바꾼다.
// 그러지 않으면 경계 검증이 HTTP 실패를 스키마 위반으로 잘못 보고한다.
const normalize = async <T>(pending: Promise<unknown>): Promise<T> => {
  const body = await pending
  if (axios.isAxiosError(body)) return Promise.reject(body)
  return body as T
}

const toAxiosConfig = ({
  params,
  data,
  meta,
  signal,
  withoutAuth,
  headers,
  preventErrorToast,
}: RequestConfig = {}) => ({
  params: meta ? { ...(params as Record<string, unknown>), ...meta } : params,
  data,
  signal,
  ...(headers && { headers }),
  ...(withoutAuth && { withoutAuth }),
  ...(preventErrorToast === true && { preventErrorToast: true }),
  ...(Array.isArray(preventErrorToast) && { preventToastCodes: preventErrorToast }),
  // trackingProps 는 이 앱에 그것을 읽는 인터셉터가 없어 옮기지 않는다
})

export const domainHttpClient: HttpClient = {
  get: (url, config) => normalize(maxios.get(url, toAxiosConfig(config))),
  post: (url, body, config) => normalize(maxios.post(url, body, toAxiosConfig(config))),
  put: (url, body, config) => normalize(maxios.put(url, body, toAxiosConfig(config))),
  patch: (url, body, config) => normalize(maxios.patch(url, body, toAxiosConfig(config))),
  delete: (url, config) => normalize(maxios.delete(url, toAxiosConfig(config))),
  // 응답 인터셉터가 응답 객체를 벗겨 헤더가 남지 않으므로 파일명은 알 수 없다
  getFile: (url, config) =>
    normalize<Blob>(maxios.get(url, { ...toAxiosConfig(config), responseType: 'blob' })).then(
      (blob) => ({ blob, fileName: null }),
    ),
}
